import React from "react";
import { Box, Typography } from "@mui/material";

const PermissionDenied = () => {
  return (
    <Box role="alert" aria-live="polite">
      <Typography variant="h5" gutterBottom>
        No access
      </Typography>
      <Typography variant="body1">You do not have permission to view this page.</Typography>
    </Box>
  );
};

export default PermissionDenied;
